var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankingArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77824 1.22176C7.16877 0.831231 7.80193 0.831231 8.19246 1.22176L14.2635 7.29282C14.8935 7.92279 14.4473 8.99993 13.5564 8.99993L1.41428 8.99993C0.52338 8.99993 0.0772123 7.92279 0.707177 7.29282L6.77824 1.22176Z",
    fill: "#16E79C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingArrowUp);
export default __webpack_public_path__ + "static/media/ranking-arrow-up.67e0d6177cf9a6391a20d8f8472c0b48.svg";
export { ForwardRef as ReactComponent };